import { render } from "./PostalCardDetail.vue?vue&type=template&id=19c629fa&scoped=true&ts=true"
import script from "./PostalCardDetail.vue?vue&type=script&lang=ts"
export * from "./PostalCardDetail.vue?vue&type=script&lang=ts"

import "./PostalCardDetail.vue?vue&type=style&index=0&id=19c629fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c629fa"]])

export default __exports__